import Carousel from 'react-material-ui-carousel'
import {CardMedia} from '@mui/material'

import './banners.scss'

const Banners = ({images}) => {
    const handleClick = (image) => console.table(image)
    const secureImages = images.map(image => image.replace('http://', 'https://'))
    return <Carousel className={'div-banner'} indicators={true}>
        {secureImages.map((image, key) => {
            return <CardMedia onClick={() => handleClick(image)} crossOrigin={'anonymous'} alt={'Imagem de exemplo'}
                              style={{objectFit: 'cover'}} key={key} className={'banner'} image={image}/>
        })}
    </Carousel>
}

export default Banners
